<template>
  <div>
    <el-dialog
      :before-close="handleClose"
      title="日志"
      :visible.sync="Open"
      width="660px"
      :close-on-click-modal="false"
    >
      <div style="max-height: 600px; overflow: auto">
        <BaseTable ref="baseTable" :fn-init="Fninit" :table="table" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { list } from '@/api/log/operlog.js'
  export default {
    components: {},
    props: {
      logType: {
        type: String,
        default: '',
      },
      moduleId: {
        type: String,
        default: null,
      },
    },
    data() {
      let _this = this
      return {
        Open: true,
        table: {
          name: '',
          defaultParams: {},
          showSearchBar: false,
          searchOptions: [],
          canRefresh: false, // 刷新按钮
          showMoreBtns: false, // 展示新增按钮
          noPage: true,
          moreBtns: [],
          dictKey: [
            {
              type: 'businessType',
              source: 'ENUM',
            },
          ],
          // 草稿 tempStorage  1 2
          options: [
            {
              label: '操作人',
              key: 'userName',
              align: 'center',
              type: 'name',
              visible: true,
            },
            {
              label: '操作类型',
              key: 'businessType',
              type: 'dict',
              dictKey: 'businessType',
              visible: true,
              align: 'center',
            },
            {
              label: '操作详情',
              key: 'operInfo',
              type: 'name',
              align: 'center',
              overflow: 20,
              visible: true,
            },
            {
              label: '操作时间',
              key: 'createTime',
              align: 'center',
              type: 'name',
              visible: true,
            },
          ],
        },

        Fninit: () => {
          return {
            initData(params) {
              params.moduleId = _this.moduleId
              params.logType = _this.logType
              return new Promise((resolve) => {
                list(params).then((res) => {
                  resolve(res)
                })
              })
            },
            clearOptions() {
              // 重置清空搜索框
              this.table.defaultParams = {}
              this.table.searchOptions = []
            },
          }
        },
      }
    },
    created() {},
    mounted() {
      this.resetForm('form')
    },
    methods: {
      dialogConfirm() {
        this.handleClose()
      },
      handleClose() {
        this.$emit('getLog')
      },
    },
  }
</script>
<style lang="scss" scoped></style>
